module.exports = __webpack_public_path__ + "img/ia-reputation.2178562a.svg";